import es from './locale/es';

/** WizzyChat: solo español — no cargar otros bundles de idioma. */
export default { es };
